import MuiToggleButton, { ToggleButtonProps as MuiToggleButtonProps } from '@mui/material/ToggleButton';
import React from 'react';

export type ToggleButtonProps = MuiToggleButtonProps;

export const ToggleButton = (props: ToggleButtonProps) => {
  return <MuiToggleButton {...props} />;
};
